import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SometimesInlineFiltersCheckBox } from './Filters.styles';
import { FilterOptions } from '@zoopla/redux-types/filters.types';

import { updateFilter, mustHavesSelector } from '@zoopla/redux-reducer-filters';
import { listItemToggle } from '@zoopla/listing-search-context';

export const SelectFeatures: FC = () => {
    const reduxDispatch = useDispatch();

    const { selectedValue: mustHaves, options } =
        useSelector(mustHavesSelector);

    const onFeaturesChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const newMustHaves = listItemToggle(mustHaves, evt.currentTarget.value);
        reduxDispatch(updateFilter('mustHaves', newMustHaves));
    };

    return (
        <FeaturesCheckboxes
            mustHaveOptions={options}
            onFeaturesChange={onFeaturesChange}
            mustHaves={mustHaves}
        />
    );
};

type Props = {
    mustHaveOptions: FilterOptions;
    onFeaturesChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    mustHaves: string[];
};

const FeaturesCheckboxes: FC<Props> = ({
    mustHaveOptions,
    onFeaturesChange,
    mustHaves
}) => (
    // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
        {mustHaveOptions?.map((mustHaveOption, index) => {
            const { value, label } = mustHaveOption;

            const isChecked = mustHaves.includes(value);

            return (
                <SometimesInlineFiltersCheckBox
                    id={value}
                    key={`${value}-${index}`}
                    value={value}
                    onChange={onFeaturesChange}
                    label={label}
                    checked={isChecked}
                />
            );
        }) ?? []}
    </>
);
